import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useForm } from '../hooks/useForm';
import { TextField, LoadingSpinner } from '../layout';
import { setDocumentTitle } from '../utils/titleUtils';

const Login = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, isLoading: authLoading } = useAuth();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { values, handleChange } = useForm({
    username: '',
    password: ''
  });

  useEffect(() => {
    setDocumentTitle('Login');
  }, []);

  // Redirect to dashboard if already authenticated
  useEffect(() => {
    if (isAuthenticated && !authLoading) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, authLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(values);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Login fallito. Controlla le tue credenziali.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-red-50 px-4">
      <div className="absolute inset-0 bg-[radial-gradient(#cd212a_0.5px,transparent_0.5px)] [background-size:24px_24px] opacity-20" />

      <div className="relative w-full max-w-md">
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden border border-red-100">
          {/* Red header bar */}
          <div className="p-6 flex justify-center" style={{ background: 'linear-gradient(to right, #cd212a, #a91b23)' }}>
            <img
              src="/logo-w.png"
              alt="Faraone"
              className="h-10 w-auto"
            />
          </div>

          <div className="p-8">
            <div className="text-center mb-6">
              <p className="text-gray-600">Accedi per continuare</p>
            </div>

            {error && (
              <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-lg text-sm border border-red-200">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="space-y-4">
                <TextField
                  label="Username"
                  id="username"
                  name="username"
                  value={values.username}
                  onChange={handleChange}
                  required
                  fullWidth
                />

                <TextField
                  label="Password"
                  id="password"
                  name="password"
                  type="password"
                  value={values.password}
                  onChange={handleChange}
                  required
                  fullWidth
                />

                <div className="pt-2">
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="w-full py-3 px-4 text-white font-medium rounded-lg transition-all duration-200 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                    style={{ background: 'linear-gradient(to right, #cd212a, #a91b23)' }}
                  >
                    {isLoading ? <LoadingSpinner size="sm" /> : 'Accedi'}
                  </button>
                </div>
              </div>
            </form>

            <div className="mt-6 text-center text-sm text-gray-500">
              <p>© {new Date().getFullYear()} Faraone Srl. Tutti i diritti riservati.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
